/**
 * 模块：系统事件报警
 * 作者：haikuo.zhang
 * 时间：2021-09-14
 */

import state from './state';
import actions from './actions';
import mutations from './mutations';

export default {
    state,
    actions,
    mutations
};
